export default {
    name: 'Navbar',

    data() {
        return {
            sections: [
                {
                    key: '/profile',
                    title: 'Mi perfil'
                },
                {
                    key: '/account/config',
                    title: 'Config. de cuentas'
                },
                {
                    key: '/account/documents',
                    title: 'Documentación'
                },
                {
                    key: '/account/iiff',
                    title: 'Informes fiscales'
                },
                {
                    key: '/account/notifications',
                    title: 'Notificaciones'
                }
            ]
        };
    },

    methods: {
        checkRoute() {
            let isActive = false;

            this.sections.filter(section => {
                if (this.$route.path === section.key) {
                    isActive = true;
                }
            });

            if (isActive) {
                return 'd-none d-lg-block';
            } else {
                return 'd-none';
            }
        }
    }
};
